import { SET_DECLINED_SERVICES, CLEAR_SERVICES } from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.declined, { type, payload }) {
  switch (type) {
    case SET_DECLINED_SERVICES:
      return payload;
    case CLEAR_SERVICES:
    case RESET_APP_STATE:
      return initialState.declined;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/declined/reducer.js